import { defineStore } from 'pinia'
import { computed, reactive } from 'vue'

export const useEditStateStore = defineStore('editState', () => {
    const editStates = reactive<Record<string, boolean>>({})

    function register(keys: string[]) {
        for (const key of keys) {
            if (undefined === key) {
                return
            }
            if (!(key in editStates)) {
                editStates[key] = false
            }
        }
    }

    function set(key: string, value: boolean) {
        if (key) {
            editStates[key] = value
        }
    }

    function resetAll() {
        for (const key in editStates) {
            editStates[key] = false
        }
    }

    const hasOpenEdits = computed(() => {
        return Object.values(editStates).some((value) => value === true)
    })

    return {
        editStates,
        register,
        set,
        resetAll,
        hasOpenEdits
    }
})
